module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-15-14-636.a0ecf1b6.mp4";